"use strict";

var _classCallCheck = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/urbit-live-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MethodDataType = void 0;

var ethUtil = require("ethereumjs-util");

var _ = require("lodash");

var set_1 = require("../abstract_data_types/types/set");

var constants_1 = require("../utils/constants");

var tuple_1 = require("./tuple");

var MethodDataType = /*#__PURE__*/function (_set_1$AbstractSetDat) {
  _inherits(MethodDataType, _set_1$AbstractSetDat);

  var _super = _createSuper(MethodDataType);

  function MethodDataType(abi, dataTypeFactory) {
    var _this;

    _classCallCheck(this, MethodDataType);

    var methodDataItem = {
      type: 'method',
      name: abi.name,
      components: abi.inputs
    };
    _this = _super.call(this, methodDataItem, dataTypeFactory);
    _this._methodSignature = _this._computeSignature();
    _this._methodSelector = _this._computeSelector();
    var returnDataItem = {
      type: 'tuple',
      name: abi.name,
      components: abi.outputs
    };
    _this._returnDataType = new tuple_1.TupleDataType(returnDataItem, _this.getFactory());
    return _this;
  }

  _createClass(MethodDataType, [{
    key: "encode",
    value: function encode(value, rules) {
      var calldata = _get(_getPrototypeOf(MethodDataType.prototype), "encode", this).call(this, value, rules, this._methodSelector);

      return calldata;
    }
  }, {
    key: "decode",
    value: function decode(calldata, rules) {
      var value = _get(_getPrototypeOf(MethodDataType.prototype), "decode", this).call(this, calldata, rules, this._methodSelector);

      return value;
    }
  }, {
    key: "strictDecode",
    value: function strictDecode(calldata, rules) {
      var value = _get(_getPrototypeOf(MethodDataType.prototype), "decode", this).call(this, calldata, Object.assign(Object.assign({}, rules), {
        isStrictMode: true
      }), this._methodSelector);

      var valueAsArray = _.isObject(value) ? _.values(value) : [value];

      switch (valueAsArray.length) {
        case 0:
          return undefined;

        case 1:
          return valueAsArray[0];

        default:
          return valueAsArray;
      }
    }
  }, {
    key: "encodeReturnValues",
    value: function encodeReturnValues(value, rules) {
      var returnData = this._returnDataType.encode(value, rules);

      return returnData;
    }
  }, {
    key: "decodeReturnValues",
    value: function decodeReturnValues(returndata, rules) {
      var returnValues = this._returnDataType.decode(returndata, rules);

      return returnValues;
    }
  }, {
    key: "strictDecodeReturnValue",
    value: function strictDecodeReturnValue(returndata, rules) {
      var returnValues = this._returnDataType.decode(returndata, Object.assign(Object.assign({}, rules), {
        isStrictMode: true
      }));

      var returnValuesAsArray = _.isObject(returnValues) ? _.values(returnValues) : [returnValues];

      switch (returnValuesAsArray.length) {
        case 0:
          return undefined;

        case 1:
          return returnValuesAsArray[0];

        default:
          return returnValuesAsArray;
      }
    }
  }, {
    key: "getSignatureType",
    value: function getSignatureType() {
      return this._methodSignature;
    }
  }, {
    key: "getSelector",
    value: function getSelector() {
      return this._methodSelector;
    }
  }, {
    key: "getReturnValueDataItem",
    value: function getReturnValueDataItem() {
      var returnValueDataItem = this._returnDataType.getDataItem();

      return returnValueDataItem;
    }
  }, {
    key: "_computeSignature",
    value: function _computeSignature() {
      var memberSignature = this._computeSignatureOfMembers();

      var methodSignature = "".concat(this.getDataItem().name).concat(memberSignature);
      return methodSignature;
    }
  }, {
    key: "_computeSelector",
    value: function _computeSelector() {
      var signature = this._computeSignature();

      var selector = ethUtil.bufferToHex(ethUtil.toBuffer(ethUtil.keccak256(Buffer.from(signature)).slice(constants_1.constants.HEX_SELECTOR_BYTE_OFFSET_IN_CALLDATA, constants_1.constants.HEX_SELECTOR_LENGTH_IN_BYTES)));
      return selector;
    }
  }]);

  return MethodDataType;
}(set_1.AbstractSetDataType);

exports.MethodDataType = MethodDataType;